import type { ClientOrganization } from '@DigitaleDoerfer/digitale-doerfer-api';

export const createDefaults = (): { mayorGreeting: string } => ({
  mayorGreeting: ''
});

export const editDefaults = (
  organization: ClientOrganization
): { mayorGreeting: string } => ({
  mayorGreeting: organization.data?.territorialAuthority?.mayorGreeting ?? ''
});
